export const VIDEO_ICON =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" > <path d="M17 10.5v3l4 3v-9l-4 3z" />  <path d="M15 7H3c-1.11 0-2 .9-2 2v6 c0 1.1.89 2 2 2h12 c1.11 0 2-.9 2-2V9 c0-1.1-.89-2-2-2z" /> </svg>';

export const HR_ICON =
  '<svg style="cursor: pointer" width="24" height="24" focusable="false"><path d="M4 11h16v2H4z" fill-rule="evenodd"></path></svg>';

export const PASTE_AS_TEXT_ICON = `<svg width="24" height="24" focusable="false"><path d="M18 9V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v13h3V9h9zM9 20H6a2 2 0 01-2-2V5c0-1.1.9-2 2-2h3.2A3 3 0 0112 1a3 3 0 012.8 2H18a2 2 0 012 2v4h1v12H9v-1zm1.5-9.5v9h9v-9h-9zM12 3a1 1 0 00-1 1c0 .5.4 1 1 1s1-.5 1-1-.4-1-1-1zm0 9h6v2h-.5l-.5-1h-1v4h.8v1h-3.6v-1h.8v-4h-1l-.5 1H12v-2z" fill-rule="nonzero"></path></svg>`;

export const REMOVE_FORMATTING_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6,5V5.18L8.82,8H11.22L10.5,9.68L12.6,11.78L14.21,8H20V5H6M3.27,5L2,6.27L8.97,13.24L6.5,19H9.5L11.07,15.34L16.73,21L18,19.73L3.55,5.27L3.27,5Z" /></svg>`;

export const FORMATS = {
  alignleft: [
    {
      selector: "figure.image",
      collapsed: false,
      classes: "align-left",
      ceFalseOverride: true,
      preview: "font-family font-size",
    },
    {
      selector: "p",
      styles: {
        textAlign: "left",
      },
      inherit: false,
      preview: false,
    },
    {
      selector: "figure,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li",
      styles: {
        textAlign: "left",
      },
      inherit: false,
      preview: false,
      defaultBlock: "div",
    },
    {
      selector: "img,table,audio,video",
      collapsed: false,
      styles: {
        float: "left",
      },
      preview: "font-family font-size",
    },
  ],

  aligncenter: [
    {
      selector: "p",
      styles: {
        textAlign: "center",
      },
      inherit: false,
      preview: "font-family font-size",
    },
    {
      selector: "figure,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li",
      styles: {
        textAlign: "center",
      },
      inherit: false,
      preview: "font-family font-size",
      defaultBlock: "div",
    },
    {
      selector: "figure.image",
      collapsed: false,
      classes: "align-center",
      ceFalseOverride: true,
      preview: "font-family font-size",
    },
    {
      selector: "img,audio,video",
      collapsed: false,
      styles: {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
      },
      preview: false,
    },
    {
      selector: "table",
      collapsed: false,
      styles: {
        marginLeft: "auto",
        marginRight: "auto",
      },
      preview: "font-family font-size",
    },
  ],

  alignright: [
    {
      selector: "figure.image",
      collapsed: false,
      classes: "align-right",
      ceFalseOverride: true,
      preview: "font-family font-size",
    },
    {
      selector: "p",
      styles: {
        textAlign: "right",
      },
      inherit: false,
      preview: "font-family font-size",
    },
    {
      selector: "figure,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li",
      styles: {
        textAlign: "right",
      },
      inherit: false,
      preview: "font-family font-size",
      defaultBlock: "div",
    },
    {
      selector: "img,table,audio,video",
      collapsed: false,
      styles: {
        float: "right",
      },
      preview: "font-family font-size",
    },
  ],

  alignjustify: [
    {
      selector: "p",
      styles: {
        textAlign: "justify",
      },
      inherit: false,
      preview: "font-family font-size",
    },
    {
      selector: "figure,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li",
      styles: {
        textAlign: "justify",
      },
      inherit: false,
      defaultBlock: "div",
      preview: "font-family font-size",
    },
  ],
};
